// mainBannerNew.js
import GLightbox from 'glightbox';

const classPrefix = 'main-banner-new';
const dataAttr     = 'data-main-banner-new';

export function mainBannerNew() {
    const container = document.querySelector(`[${dataAttr}]`);
    if (!container) return;

    const wrapper = container.querySelector(`.${classPrefix}__ticker-wrapper`);
    const slides  = Array.from(wrapper.children);

    // клонируем первый слайд в конец
    const firstClone = slides[0].cloneNode(true);
    wrapper.appendChild(firstClone);

    const total = slides.length + 1; // real + clone
    const slideH = slides[0].offsetHeight;

    let idx = 0;
    const pause = 2000; // ms показа
    const move  = 400;  // ms скролла

    function goNext() {
        idx++;
        wrapper.style.transition = `transform ${move}ms linear`;
        wrapper.style.transform  = `translateY(-${idx * slideH}px)`;

        // когда дошли до клона — «отматываем» назад на 0
        if (idx === total - 1) {
            wrapper.addEventListener('transitionend', reset, { once: true });
        }
    }

    function reset() {
        // сразу без анимации
        wrapper.style.transition = 'none';
        wrapper.style.transform  = 'translateY(0)';
        idx = 0;
        // небольшой таймаут перед следующим слайдом
        setTimeout(() => wrapper.style.transition = `transform ${move}ms linear`, 20);
    }

    // стартуем цикл
    setTimeout(function loop() {
        goNext();
        setTimeout(loop, pause + move);
    }, pause + move);

    // === GLightbox-логика (как было) ===
    container.querySelectorAll('.glightbox').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            const href = el.dataset.videoUrl;
            const player = GLightbox({
                elements: [{
                    href,
                    type: 'video',
                    source: 'local'
                }],
                autoplayVideos: true,
                openEffect: 'fade',
                closeEffect: 'fade'
            });
            player.open();
        });
    });
}

// инициализация
const root = document.querySelector(`[${dataAttr}]`);
if (root) window.addEventListener('DOMContentLoaded', mainBannerNew);
